import { useCallback, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Pagination } from "../../components/Pagination";
import ErrorMessageBox from "../../components/ErrorMessageBox";
import { Loading } from "../../components/Loading";
import _ from "lodash";
import useQueryString from "../../../utils/hooks/useQueryString";
import { UserBookListItem } from "./UserbookListItem";
import { NoData } from "app/components/NoData";
import { scrollToElement } from "lib/userFunctions";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";

const queryString = require("query-string");

export const UserBookList = () => {
    const navigate = useNavigate();
    const queryParams = useQueryString();
    const { school } = useParams();
    const [keyword, setKeyword] = useState("");

    const requestData = useMemo(() => {
        let paramJson = { page: 0, list: "", keyword: "", sort: "updatedAt,desc", creative: "Y" };
        paramJson = { ...paramJson, ...queryParams };
        if (!_.includes(["updatedAt,desc", "keepCount,desc", "readCount,desc", "likeCount,desc", "commentCount,desc",], paramJson.sort)) {
            paramJson.sort = "updatedAt,desc";
        }
        setKeyword(paramJson.keyword);

        return paramJson;
    }, [queryParams]);


    const { data: userBookList, isError, isFetching, error, isSuccess } = useQuery({
        queryKey: ['userbook/list', requestData],
        queryFn: () => Api.post(`/api/userBook/list?page=${requestData.page}&sort=${requestData.sort}`, requestData),
        placeholderData: keepPreviousData
    });

    const fetchList = useCallback((page = 0, searchOption = {}) => {
        let tempSearchOption = { ...requestData, ...searchOption, page: page };
        scrollToElement("userBookList");
        navigate(`/${school}/userbook?${queryString.stringify(tempSearchOption)}`);
    }, [navigate, requestData, school]);

    const onChangeKeyword = useCallback((e) => {
        fetchList(0, { keyword });
        e.preventDefault();
    }, [fetchList, keyword]);

    const onSearchEnter = useCallback(
        (e) => {
            if (e.key === "Enter") {
                onChangeKeyword(e);
            }
        },
        [onChangeKeyword]
    );

    const list = useMemo(() => {
        if (isError) {
            console.log(error);
            return <ErrorMessageBox message={createFetchErrorMessage(error).message}
                goto={<Link to={`/${school}/userbook`} className="btn _border" >목록</Link>} />;

        }
        if (userBookList?.data?.list.length <= 0) {
            return <NoData title="나도 작가다 작품" className="col-12" url={`/${school}/userbook/create`}
                desc="내가 직접 작가가 되어 재미있는 작품을 만들어보는건 어떨까요?" />;
        }

        return userBookList?.data?.list.map((userBook) => <UserBookListItem userBook={userBook} key={userBook.id} />);
    }, [school, userBookList, isError, error]);

    return (
        <div id="userBookList" className="userBookList">
            <div className="inner">
                <div className="bbs_search">
                    <div className="search_area">
                        <form onSubmit={onChangeKeyword}>
                            <input type="text" name="keyword" className="search_input"
                                value={keyword} onChange={(e) => setKeyword(e.target.value)}
                                onKeyDown={onSearchEnter}
                                placeholder="검색어를 입력하세요."
                            />
                            <button type="submit" className="search_btn" onClick={onChangeKeyword}></button>
                        </form>
                    </div>
                </div>

                <div className={`listContainer ${requestData.list}`}>
                    <ul className="grid-row">
                        {list}
                    </ul>
                    <Loading overlay={true} active={isFetching} />
                </div>
                {isSuccess && <Pagination page={userBookList?.data?.page} totalPage={userBookList?.data?.totalPages} gotoPage={fetchList} />}
            </div>
        </div>
    );
};
